/* eslint-disable no-console,no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  StyledModal, CalendarWrapper, ConfirmVisitText,
} from '../PeopleHomeV2/ManageBuddies/styles';
import { HeadingBranding } from './styles';
import {ButtonWrapper} from '../HrisIntegration/style'
import {WarningDelete, RecognitionCloseIcon, DustbinIcon, RemoveUserIcon} from '../../utils/icons'

class DeletePopup extends Component {
  constructor(props) {
    super(props);
    this.state={
      showSingleClick: false
    }
  }

  deleteConsumerHandle = () => {
    const {deleteConsumer } = this.props;
    this.setState({
      showSingleClick: true
    }, () => deleteConsumer())
  }

  render() {
    const { showModal, onClose, type, isChallengePopup, title, heading, subHeading } = this.props;
    const {showSingleClick} = this.state
    return (
      <StyledModal show={showModal ? true : false} width={"400px"} paddingV='16px'>
        <HeadingBranding>
          <div className='warning'>
            {WarningDelete()}
          </div>
          {isChallengePopup?title: type? `Delete ${type} `:`Delete Integration`}
          <div className='close' onClick={()=>onClose()}>
            {RecognitionCloseIcon('#F37A65')}
          </div>
        </HeadingBranding>
        <div style={{background:"#EFEFEF", height:"1px", width:"100%", marginTop:"20px"}}/>
        <CalendarWrapper padding="0">
          {
            <ConfirmVisitText isTopData margin="20px 0px 20px 0px" display="block">
              <div className='text'> {isChallengePopup?heading: `Are you sure you want to delete this ${type ?type:"Integration"}?`}</div>
              { 
                isChallengePopup?<div className='danger'>{subHeading}</div>:
                  type?
                    <div className='danger'>
                    This action cannot be undone, and all associated<br/> data will be permanently removed from the system.
                    </div>:
                    <div className='danger'>
                    This action cannot be undone, and the HRIS<br/> authentication and permissions will be permanently<br/> removed from the system.
                    </div>}
            </ConfirmVisitText>
          }  
          <ButtonWrapper>
            <div className='cancel' onClick={() => onClose()}>{type==="initiative"||isChallengePopup?`Keep ${type}`: "Cancel"}</div>
            <div className='create' onClick={showSingleClick?null:() => this.deleteConsumerHandle()}>
              <div className='icon'>
                {isChallengePopup? RemoveUserIcon("#F8F8F8"): DustbinIcon()}
              </div>
              {isChallengePopup?"Confirm Removal": type==="initiative"?`Delete ${type}`:"Delete Permanently"}
            </div>
          </ButtonWrapper>
        </CalendarWrapper>
      </StyledModal>
    );
  }
}

DeletePopup.propTypes = {
  showModal: PropTypes.string,
  onClose: PropTypes.func,
  deleteConsumer: PropTypes.func,
  type: PropTypes.string,
  title: PropTypes.string,
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  isChallengePopup: PropTypes.bool
};

export default DeletePopup;